// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__yvzmQ","right":"card_right__NH3oh","notes_text":"card_notes_text__CuFcp","expand":"card_expand__6LfPA"};